import { gql } from "graphql-request";

export const ProposalFieldsFragment = gql`
  fragment ProposalFieldsFragment on ProposalSearchResult {
    proposalId
    name
    subdomain
    budgetId
    budgetName
  }
`;
